export const palette = {
  primary: {
    main: '#995A00',
    light: '#FFBF40',
    dark: '#A56100',
    contrastText: '#fff',
  },
  secondary: {
    main: '#01522B',
    contrastText: '#fff',
  },
  error: {
    main: '#F9485A',
    light: '#FFBDBD',
  },
  success: {
    main: '#4CAF50',
  },
  warning: {
    main: '#FFBF40',
  },
  info: {
    main: '#2196F3',
  },
  text: {
    primary: '#333333',
    secondary: '#666666',
    disabled: '#BDBDBD',
  },
  background: {
    default: '#FFFFFF',
    // paper: '#F5F5F5',
  },
  grey: {
    100: '#F5F5F5',
    700: '#616161',
    900: '#212121',
  },
};